import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ProductTabs = ({ product }) => {
  const [activeTab, setActiveTab] = useState('description');

  const tabs = [
    { id: 'description', label: 'Description', icon: 'FileText' },
    { id: 'nutrition', label: 'Nutrition', icon: 'Activity' },
    { id: 'ingredients', label: 'Ingredients', icon: 'List' },
    { id: 'storage', label: 'Storage', icon: 'Package' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'description':
        return (
          <div className="space-y-4">
            <p className="text-text-primary font-body leading-relaxed">
              {product.description}
            </p>
            {product.features && (
              <div>
                <h4 className="font-heading font-heading-semibold text-text-primary mb-3">
                  Key Features:
                </h4>
                <ul className="space-y-2">
                  {product.features.map((feature, index) => (
                    <li key={index} className="flex items-start space-x-2">
                      <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                      <span className="text-text-primary font-body">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      
      case 'nutrition':
        return (
          <div className="space-y-4">
            <div className="bg-background rounded-card p-4">
              <h4 className="font-heading font-heading-semibold text-text-primary mb-4">
                Nutrition Facts (per {product.servingSize})
              </h4>
              <div className="grid grid-cols-2 gap-4">
                {Object.entries(product.nutrition).map(([key, value]) => (
                  <div key={key} className="flex justify-between items-center py-2 border-b border-border last:border-b-0">
                    <span className="font-body text-text-primary capitalize">
                      {key.replace(/([A-Z])/g, ' $1').trim()}
                    </span>
                    <span className="font-data font-data-medium text-text-primary">
                      {value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      
      case 'ingredients':
        return (
          <div className="space-y-4">
            <div>
              <h4 className="font-heading font-heading-semibold text-text-primary mb-3">
                Ingredients:
              </h4>
              <p className="text-text-primary font-body leading-relaxed">
                {product.ingredients}
              </p>
            </div>
            {product.allergens && (
              <div className="bg-warning/10 border border-warning/20 rounded-card p-4">
                <div className="flex items-start space-x-2">
                  <Icon name="AlertTriangle" size={20} className="text-warning mt-0.5 flex-shrink-0" />
                  <div>
                    <h5 className="font-heading font-heading-semibold text-warning mb-2">
                      Allergen Information:
                    </h5>
                    <p className="text-text-primary font-body">
                      {product.allergens}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      
      case 'storage':
        return (
          <div className="space-y-4">
            <div>
              <h4 className="font-heading font-heading-semibold text-text-primary mb-3">
                Storage Instructions:
              </h4>
              <p className="text-text-primary font-body leading-relaxed mb-4">
                {product.storageInstructions}
              </p>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-background rounded-card p-4">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Thermometer" size={20} className="text-primary" />
                  <span className="font-body-semibold text-text-primary">Temperature</span>
                </div>
                <p className="text-text-secondary font-body">{product.storageTemp}</p>
              </div>
              <div className="bg-background rounded-card p-4">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Calendar" size={20} className="text-primary" />
                  <span className="font-body-semibold text-text-primary">Shelf Life</span>
                </div>
                <p className="text-text-secondary font-body">{product.shelfLife}</p>
              </div>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="bg-surface rounded-card shadow-card">
      {/* Tab Navigation */}
      <div className="border-b border-border">
        <div className="flex overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-3 font-body-semibold whitespace-nowrap transition-smooth border-b-2 ${
                activeTab === tab.id
                  ? 'text-primary border-primary' :'text-text-secondary border-transparent hover:text-primary hover:border-primary/50'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-6">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ProductTabs;